// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fj-3";
export var flatBottomCorners = "_fj-5";
export var productImage = "_fj-0";
export var quantityContainer = "_fj-2";
export var quantityHeader = "_fj-6";
export var tooltip = "_fj-1";
export var wrapAndEllipsesOverflow = "_fj-4";